import React from "react";
import TextInput from "./TextInput";

class TextFieldEditor extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            value: props.value === undefined || props.value === null ? "" : props.value
        }
        this.inputRef = React.createRef();
    }

    getValue = () => {
        if(this.props.column && this.props.column.colDef && this.props.column.colDef.cellEditorParams && this.props.column.colDef.cellEditorParams.format){
            if(this.state.value && this.state.value !== this.props.value ){
                return this.props.column.colDef.cellEditorParams.format.test(this.state.value) ?
                   this.state.value : null;
            }
        }
        return this.state.value;
    }

    isPopup = () => {
        return false;
    }

    afterGuiAttached(){
        this.focusOnInput();
    }

    focusOnInput = () => {
        if(this.inputRef && this.inputRef.current){
            this.inputRef.current.focus();
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.column && this.props.column.colDef && this.props.column.colDef.field != prevProps.column.colDef.field){
            this.setState({
                value:  this.props.value === undefined || this.props.value === null ? "" : this.props.value
            });
        }
        this.focusOnInput();
    }

    handleChange = (event) => {
        let value = event && event.target.value ?  event.target.value : ""
        if(this.props.column && this.props.column.colDef.cellEditorParams && this.props.column.colDef.cellEditorParams.capitalize){
            value = value.toString().trim().toUpperCase();
        }
        this.setState({
            value
        });
        this.props.onChange?.(value);
    }

    // Gets called once before editing starts, to give editor a chance to
    // cancel the editing before it even starts.
    isCancelBeforeStart(){
        const { colDef } = this.props.column || {};
        return colDef && colDef.type === "isCancelBeforeStart";
    }

    render(){
        const editorParams = this.props.column && this.props.column.colDef && this.props.column.colDef.cellEditorParams ||{};
        return (
            <TextInput
                onChange={this.handleChange}
                value={this.state.value}
                inputRef={this.inputRef}
                {...editorParams}
                >
            </TextInput>
        )
    }
}
export default TextFieldEditor;